import type { AnalyticsContextModel, AnyData } from "@asurion-core/eventualize";

import { env } from "@/config";
import { getSelectedSession, useAgentStore } from "@/sdk";
import { userCache } from "@/shared-utils";

// TODO: Once this expands, move somewhere else, or create a simple enhancer registration/deregistration mechanism that works for our platform integrations
/** Enhances all dispatcher dispatches with fundamental, global, information */
export function enhanceAnalytics(_eventName: string, _eventData: AnyData, context: AnalyticsContextModel) {
    const { id: sessionId, currentTask } = getSelectedSession();

    context.app.commitHash = env.commitHash;
    context.identities.WorkerId = useAgentStore.getState().agentId;
    context.identities.Username = useAgentStore.getState().agentName;
    context.identities.EmpId = userCache.employeeId ?? undefined;

    Object.assign(context.identities, currentTask?.analyticsData);

    if (currentTask && !context.identities.TaskId) {
        context.identities.TaskId = currentTask.id;
    }

    // mixpanel identity (enables uniques + funnels)
    context.identities.ExpertId = userCache.employeeId ?? undefined;

    context.identities.SalesforceId = userCache.salesforceId ?? undefined;

    // Guard to prevent overwriting the session id if it's already set
    if (!context.identities.SessionId) {
        context.identities.SessionId = sessionId;
    }

    // legacy identity for SoCo backwards compat
    context.identities.SupportSessionId = context.identities.SessionId;
}
